import AuthContext from '../../context/AuthContext';
import WithGASetup from '../WithGASetup';
import ViewProfile from './ViewProfile';

export default WithGASetup(ViewProfile, AuthContext);
